<template>
  <div id='creatOrder' v-if='computedOrderStep!=0'>
  
    <div class='cartBox' v-if='computedOrderStep==1'>
        <div class='boxTop'>
            <div class='boxName'>您的橘袋{{computTime}}</div>
            <img :src="closeImg"  @click='closeCart'>
        </div>
        <div  class='boxCont' v-if='computedCartGoods.length<1'>
              <div style="height: 100px;line-height: 100px;">您还没有添加商品到橘袋</div>
        </div>
        <div class='boxCont' v-if='computedCartGoods.length>0'>
            <div class='boxGoods' v-for='(item,index) in computedCartGoods' :style='index==0?"border-top: 1px solid rgba(0,0,0,0.1)":""'>
                <img :src="delImg"  class='delGoods' @click='delCart' :data-id='item.id' >
                <img :src="item.shrink_img"  class='goodsImg'>
                <div class='goodsCont'>
                      <div class='cartGoodsName'>{{item.label==1?"维生素":(item.label==2?"矿物质":(item.label==3?"草本":(item.label==4?"益生菌":"专业产品")))}}：{{item.goods_name}}</div>
                      <div class='cartGoodsUse'>1个月（{{item.day_use*30}}颗）</div>
                </div>
                <div class='cartGoodsSpec'>¥{{item.price}}</div>
            </div>
        </div>
        <div class='boxbottom'>
            <div class='boxbottomMoney' v-if='computedCartGoods.length>0'>
                <div  class='boxbottomAllTxt'>小计</div>
                <div  class='boxbottomAllMoney'>¥{{allMoney}}</div>
            </div>
            <div class='boxbottomFile'>
                <div class='boxbottomFileLeft' v-if='computedCartGoods.length>0'>
                    <img :src="fileImgChecked"  class='fileChick' v-if='suseeFile' @click='agrerFile'>
                    <img :src="fileImg"  class='fileChick' v-if='!suseeFile'  @click='agrerFile'>
                    <div class='xjdfile'>提交即表明你已经同意我们的<span> <router-link to="clause">使用条款</router-link></span>及<span><router-link to="privacy">隐私政策</router-link></span></div>
                </div>
                <div v-if='computedCartGoods.length<1'></div>
                <div class='boxbottomFileRight' @click='orderStep2' v-if='computedCartGoods.length>0&&suseeFile'>
                    <div style='cursor:pointer'>结算</div>
                    <img :src="rightImg" >
                </div>
                <div class='boxbottomFileRight' v-if='computedCartGoods.length<1||!suseeFile' style='background:#D8D8D8'>
                    <div style='cursor:pointer'>结算</div>
                    <img :src="rightImg" >
                </div>
            </div>
            
        </div>
    </div>
    
    <div class='addressBox' v-if='computedOrderStep==2'>
        <div class='boxTop'>
            <div class='boxName'>配送</div>
            <img :src="closeImg"  @click='closeCart'>
        </div>
        <div class='boxCont'>
             <div class='addressTxt'>{{addressTxt}}</div>
             <div class='inputBox'>
                <input type="text" v-model="name" placeholder="姓名" class='input300' maxlength="10">
             </div>
             <div class='inputBox'>
                <input type="text" v-model="idCard" placeholder="身份证号" class='input300' maxlength="18">
             </div>
             <div class='inputBox'>
                <input type="text" v-model="eMail" placeholder="电子邮箱" class='input300'>
                <input type="text" v-model="phone" placeholder="电话" class='input230' maxlength="11">
             </div>
             <div class='inputBox'>
                  <div class='input95' @click='choseShen'>
                        <div class='cityslect'>{{shen}}</div>
                        <div class="cityBox" v-show='showShen'>
                            <div v-for='item in shenCity' :data-city='item' @click='choseShenItem'>{{item}}</div>
                        </div>
                  </div>
                  <div class='input95' @click='choseShi'>
                        <div class='cityslect'>{{shi}}</div>
                        <div class="cityBox" v-show='showShi'>
                            <div v-for='item in shiCity' :data-city='item' @click='choseShiItem'>{{item}}</div>
                        </div>
                  </div>
                  <div class='input95' @click='choseQu'>
                        <div class='cityslect'>{{qu}}</div>
                        <div class="cityBox" v-show='showQu'>
                            <div v-for='item in quCity' :data-city='item' @click='choseQuItem'>{{item}}</div>
                        </div>
                  </div>
                  <input type="text" v-model="msnCode" placeholder="邮编" class='input230'>
             </div>
             <div class='inputBox'>
                  <input type="text"  v-model="addressDetail" placeholder="详细地址" class='input540'>
             </div>
             <div class='inputBox2'>
                  <textarea v-model="orderMsg" placeholder="给卖家留言（选填）" class='inputTextarea' maxlength="100"  />
             </div>
             <div class='inputBtnBox'>
                <div class='inputBtnBack' @click='orderStep1'>
                      <img :src="leftImg" >
                      <div>返回</div>
                </div>
                <div class='inputBtnPay' @click='orderStep3'>
                      <div>请选择付款方式</div>
                      <img :src="rightImg" >
                </div>
             </div>
        </div>
    </div>


    
    <div class='addressBox' v-if='computedOrderStep==3'>
        <div class='boxTop'>
            <div class='boxName'>请选择付款方式</div>
        </div>
        <div class='boxCont'>
            <div class='chosePayBox'>
                <img :src="chosePayImg" alt="">
                <div>微信支付</div>
            </div>
            <div class='showPayBox'>
                <img :src="wechatPay" alt="">
                <div>微信支付</div>
            </div>

            <div class='inputBtnBox' >
                <div class='inputBtnBack' style='width: 110px;' @click='orderStep2'>
                      <img :src="leftImg" >
                      <div>返回</div>
                </div>
                <div class='inputBtnPay' style='width: 120px;' @click='orderStep4'>
                      <div>确认信息</div>
                      <img :src="rightImg" >
                </div>
             </div>
        </div>
    </div>


    <div class='orderBox' v-if='computedOrderStep==4'>
        <div class='boxTop'>
            <div class='boxName'>收货信息</div>
            <img :src="closeImg" @click='closeCart'>
        </div>
        <div class='boxCont'>
            <div class='orderAddress'>
                  <img :src="addressImg" >
                  <div class='orderAddressBox'>
                        <div class='orderAddressName'>{{name}}</div>
                        <div class='orderAddressidBox'>
                              <div class='orderAddressPhone'>{{phone}}</div>
                              <div class='orderAddressIdCard'>{{idCard}}</div>
                        </div>
                        <div class='orderAddressDetail'>{{shen}}{{shi}}{{qu=="县/区"?"":qu}}{{addressDetail}}</div>
                  </div>
            </div>
        </div>
        <div class='boxTop' style='margin-bottom: 30px'>
            <div class='boxName'>你的订单</div>
        </div>
        <div class='boxCont'>
            <div class='orderGoods'>
                  <div class='boxGoods' v-for='item in order.orderGoods'>
                      <img :src="item.index_img" alt="" class='goodsImg'>
                      <div class='goodsCont'>
                            <div class='cartGoodsName'>{{item.label==1?"维生素":(item.label==2?"矿物质":(item.label==3?"草本":(item.label==4?"益生菌":"专业产品")))}}：{{item.goods_name}}</div>
                            <div class='cartGoodsUse'>1个月（{{item.goods_num*30}}颗）</div>
                      </div>
                      <div class='cartGoodsSpec'>¥ {{item.price}}</div>
                  </div>
                  <div class='orderGoodsTotle'>
                        <div class='orderGoodsTotleBox'>
                            <div>小计</div><div>¥ {{order.orderDetail.need_pay}}</div>
                        </div>
                        <div class='orderGoodsTotleBox'>
                            <div>税费</div><div>¥ {{order.orderDetail.tariff}}</div>
                        </div>
                        <div class='orderGoodsTotleBox'>
                            <div>配送</div><div>快递包邮</div>
                        </div>
                        
                        <div class='orderGoodsTotleBox2'>
                            <div>总计</div><div>¥ {{order.orderDetail.need_pay}}</div>
                        </div>
                  </div>
            </div>
            <div class='orderPay'>
                  <div class='xjdfile'>10分钟内未支付订单将被取消<span @click='closeCart'>取消订单</span></div> 
                  <div class='orderPayBtn' @click='orderStep5'>
                    <img :src="wechatPay" >
                    <div class='inputBtnPay'>使用微信支付</div>
                  </div>
            </div>
             
            
        </div>
    </div>

    <div class='wechatBox' v-if='computedOrderStep==5'>
        <div class='boxTop' style='text-align: center;'>
          <div> </div>
            <div class='boxName'>微信扫码支付</div>
            <img :src="closeImg"  @click='closeCart'>
        </div>
        <div class='boxCont'>
            <div class='wechatCodeBox'>
                <img :src="QRcode" alt="">
            </div>
            <div class='wechatCare'>由微信提供安全支付保障</div>
            <div class='wechatFind'>请打开微信扫一扫功能：[发现] - [扫一扫]</div>
        </div>
    </div>
    <div class='wechatBox'  v-if='computedOrderStep==6'>
        <div class='boxTop' style='text-align: center;'>
          <div> </div>
            <div class='boxName'>微信扫码支付完成</div>
            <img :src="closeImg"  @click='closeCart'>
        </div>
        <div class='boxCont'>
            <div class='wechatCodeBox'>
                <img :src="wechatGZHImg" >
            </div>
            <div class='wechatFind'>您好！您的订单已生成，若想查询订单详情请关注我们的小程序联系客服</div>
        </div>
    </div>


  </div>
</template>

<script>

const allcity = require('@/components/cityId.js').cityId;
export default {
  name: 'creatOrder',
  data:function () {
    return{
      suseeFile:true,
      closeImg:require("@/assets/colseimg.png"),
      delImg:require("@/assets/delete2.png"),
      fileImg:require("@/assets/filecheck.png"),
      fileImgChecked:require("@/assets/filechecked.png"),
      rightImg:require("@/assets/back-chevron-copy2.png"),
      leftImg:require("@/assets/icon-next2.png"),
      wechatPay:require("@/assets/wechat.png"),
      chosePayImg:require("@/assets/paychecked.png"),
      addressImg:require("@/assets/address.png"),
      wechatGZHImg:require("@/assets/qrcode_for_gh_fcfc67db8562_860@2x.png"),
      addressTxt:"欢迎您选购橘袋NUTRIPACKS营养产品，我们将会在您下单后为您立刻准备个人定制的营养补给。",
      name:"",
      idCard:"",
      eMail:"",
      phone:"",
      msnCode:"",
      addressDetail:"",
      shen:'省',
      shi:'市',
      qu:'县/区',
      orderMsg:"",
      shenCity:[],
      shiCity:[],
      quCity:[],
      showShen:false,
      showShi:false,
      showQu:false,
      productList:[],
      allMoney:0,
      QRcode:"",
      orderId:"",
      order:{},
      pay:false,
      check:false
   }
  },
  computed:{
    computTime(){
      let myDate = new Date();             
      let _year=myDate.getFullYear();        //获取当前年
      let _month=myDate.getMonth()+1;        //获取当前月
      let _date=myDate.getDate();            //获取当前日
      if(_month<10){
        _month = "0"+_month
      }
      if(_date<10){
        _date = "0"+_date
      }
      console.log(this.productList)
      return String(_year-2000) + String(_month) + String(_date)
    },
    computedOrderStep(){
      return  this.$store.state.orderStep
    },
    computedCartGoods(){
      
      let _iLength = this.productList.length
      let _jLength =this.$store.state.cartGoodsId.length
      let _cartGoods =[]
      let _allMoney = 0

      for (let i = 0; i < _iLength; i++) {
         for(let j=0;j<_jLength;j++){
            if(this.productList[i].id==this.$store.state.cartGoodsId[j]){
                _cartGoods.push(this.productList[i])
            }
         }
       }

       _cartGoods.forEach((item)=>{
          
          item.price = Number(item.shop_price*30*item.day_use).toFixed(2)
          _allMoney += Number(item.shop_price*30*item.day_use)
       })
       _allMoney=_allMoney.toFixed(2)
       this.allMoney = _allMoney
       return  _cartGoods
    }
  },
  beforeCreate:function(){
    let that = this
    this.axios({
            method: 'post',
            url: 'goods/catGoods',
            data: {
              cid: this.activeId
            }
          }).then(res=>{
            that.productList = res.data.goodsList
          })
  },
  
  created:function(){
    let _shenCity = allcity.data
    let shenCity = []
    _shenCity.forEach((item)=>{
      shenCity.push(item.name)
    })
    this.shenCity = shenCity
	
	 
  },
  methods: {
    agrerFile(){
      this.suseeFile = !this.suseeFile
    },
    delCart(e){
        this.$store.commit("saveCartNum",{cartNum:this.$store.state.cartNum,goodsId:e.target.dataset.id,add:false})
    },
    choseShen(){
      this.showShen = !this.showShen
    },
    choseShenItem(e){
      if(e.target.dataset.city != this.shen){
          this.shen = e.target.dataset.city
          this.shi='市'
          this.qu='县/区'
      }
      
    },
    choseShi(){
      if(this.shen=="省"){
        alert("请先选择省")
        return
      }
      this.showShi = !this.showShi
      let _shenCity = allcity.data
      let _shiCity = []
      let _shiList =[]
      _shenCity.forEach((item)=>{
        if( item.name == this.shen){
          _shiList = item.sonList
          }
      })
      _shiList.forEach((item)=>{
            _shiCity.push(item.name)
      })
      this.shiCity = _shiCity
    },
    choseShiItem(e){
      if(e.target.dataset.city != this.shi){
          this.shi = e.target.dataset.city
          this.qu='县/区'
      }
    },
    choseQu(){
      if(this.shi=="市"){
        alert("请先选择市")
        return
      }
      this.showQu = !this.showQu
      let _shenCity = allcity.data
      let _quCity = []
      let _shiList =[]
      let _quList = []
      _shenCity.forEach((item)=>{
        if( item.name == this.shen){
          _shiList = item.sonList
          }
      })
      _shiList.forEach((item)=>{
        if( item.name == this.shi){
          _quList = item.sonList
          }
      })
      _quList.forEach((item)=>{
        _quCity.push(item.name)
      })
      this.quCity = _quCity
    },
     choseQuItem(e){
      if(e.target.dataset.city != this.qu){
          this.qu = e.target.dataset.city
      }
    },
    closeCart(){
      this.$store.commit("saveOrderStep",0)
      this.pay = false
      this.check = false
    },
    orderStep1(){
      this.$store.commit("saveOrderStep",1)
    },
    orderStep2(){
      this.pay = false
      this.check = false
      this.$store.commit("saveOrderStep",2)
    },
    orderStep3(){
      if(this.name.length<1){
        alert("请填写姓名")
        return
      }
      if(this.idCard.length<18){
        alert("请填写正确的身份证号码")
        return
      }
      if(this.phone.length<11){
        alert("请填写正确的手机号码")
        return
      }
      if(this.shen=="省"){
        alert("请选择省份")
        return
      }
      if(this.shi=="市"){
        alert("请选择市/区")
        return
      }

      if(this.addressDetail.length<1){
        alert("请填写地址已保证您能收到橘袋")
        return
      }
 
      this.createOrderFn()
      
    },
     orderStep4(){
      let that = this

      this.axios({
                  method: 'post',
                  url: 'Order/OrderDetail',
                  data: {
                    order_id:this.orderId
                  }
                }).then(res=>{
                  console.log(res.data)

                    res.data.orderGoods.forEach((item)=>{
                          item.price = Number(item.goods_price*30*item.goods_num).toFixed(2)
                    })

                  that.order = res.data
                })

      this.$store.commit("saveOrderStep",4)
    },
     orderStep5(){
      this.$store.commit("saveOrderStep",5)
    },
    // 创建订单
    createOrderFn(){
          let that = this
          let options ={
                    goods_ids: this.$store.state.cartGoodsId,
                    receive_name:this.name,
                    receive_phone:this.phone,
                    province:this.shen,
                    city:this.shi,
                    area:this.qu,
                    address:this.addressDetail,
                    post_code:this.msnCode,
                    id_card:this.idCard,
                    order_remark:this.orderMsg,
                    order_total:this.allMoney
                    }

            this.axios({
                  method: 'post',
                  url: 'Order/pcCreateOrder',
                  data: options
                }).then(res=>{
                  if(res.data.code!=1){
                      alert("订单创建失败请重试。"+res.data.msg)
                      return
                  }
                  that.$store.commit("saveOrderStep",3)
                  that.orderId = res.data.order_id
                  that.QRcode = res.data.code_url
                  that.check = true
                  that.checkPay()
                })
               
    },
    checkPay(){
          if(!this.check)return
          let that = this
           this.axios({
                  method: 'post',
                  url: 'Order/checkOrder',
                  data: {
                    order_id:this.orderId 
                  },
                }).then(res=>{
                  if(res.data.order_status==1){
                    that.$store.commit("saveOrderStep",6)
                    that.pay = true
                    return
                  }else{
                    if(!this.pay){
                      setTimeout(()=>{
                        that.checkPay()
                      },1000)
                    }
                  }
                })
          
      
    },
  },
}
</script>  

<style>
#creatOrder{
  width: 100%;
  height:100vh;
  padding: 100px 0;
  position: fixed;
  top:0;
  left: 0;
  background-color:rgba(0,0,0,0.5);
}
.cartBox{
  padding: 30px;
  width: 660px;
  box-sizing: border-box;
  background:rgba(255,255,255,1);
  border-radius:10px;
  /*border:1px solid rgba(229,229,229,1);*/
  margin:0 auto;
  max-height: 700px;
  overflow-y:auto; 
  box-shadow:0px 0px 30px 5px rgba(0,0,0,0.31);
}
.boxTop{
  height:28px;
  display: flex;
  justify-content: space-between;
}
.boxName{
  font-size:16px;
  height:28px;
  font-family:PingFangSC-Medium;
  font-weight:600;
  color:rgba(95,95,95,1);
  line-height:28px;
  letter-spacing:1px;
}
.boxTop img{
  width: 13px;
  height:13px;
}

.boxCont{

}
.boxGoods{
  display: flex;
  height:84px;
  
  border-bottom: 1px solid rgba(0,0,0,0.1);
  padding: 12px 0;
  box-sizing: border-box;
}
.delGoods{
  width: 15px;
  height:15px;
  display: block;
  margin-right: 10px;
  position: relative;
  top:22.5px;
}
.goodsImg{
  width: 60px;
  height:60px;
  background:rgba(255,255,255,1);
  display: block;
  margin-right: 15px;
}
.goodsCont{
  flex:1;
  text-align: left;
}
.cartGoodsName{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
  line-height:20px;
  margin:8px 0 5px;
}
.cartGoodsUse{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(187,187,187,1);
  line-height:20px;
}
.cartGoodsSpec{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
  line-height:20px;
  padding-top:20px;
}
.boxbottom{
  padding-top: 6px;
}
.boxbottomMoney{
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
}
.boxbottomAllTxt{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(120,120,120,1);
  line-height:20px;
}
.boxbottomAllMoney{
  height:22px;
  font-size:16px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(120,120,120,1);
  line-height:22px;
  letter-spacing:1px;
}
.boxbottomFile{
  display: flex;
  justify-content: space-between;
  height:29px;
  line-height: 29px;
}
.boxbottomFileLeft{
   display: flex;
}
.fileChick{
  width: 12px;
  height:12px;
  display: block;
  background:rgba(255,255,255,1);
  position: relative;
  top:8px;
  margin-right: 13px;
}
.xjdfile{
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
}
.xjdfile span{
  color: rgba(73, 150, 203, 1);
  cursor:pointer;
}
.boxbottomFileRight{
   display: flex;
   justify-content: center;
   width: 75px;
   height:29px;
   background:rgba(106,181,28,1);
   border-radius:5px;
}
.boxbottomFileRight div{
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(255,255,255,1);
  margin-right: 6px;
}
.boxbottomFileRight img{
  width: 6px;
  height:10px;
  display: block;
  position: relative;
  top:9.5px;
}


.addressBox{
  padding: 30px;
  width: 600px;
  background:rgba(255,255,255,1);
  border-radius:10px;
  /*border:1px solid rgba(229,229,229,1);*/
  box-shadow:0px 0px 30px 0px rgba(202,196,191,0.31);
  margin:0 auto;
}


.addressTxt{
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
  line-height:20px;
  text-align: left;
  padding: 14px 0 10px;
}
.inputBox{
  display: flex;
  margin-bottom: 10px;
  height:30px;
  line-height: 30px;
}
.inputBox2{
  display: flex;
  margin-bottom: 10px;
  height:60px;
  line-height: 30px;
}
.input300{
  width:300px;
  height:30px;
  background:rgba(255,255,255,1);
  border-radius:5px;
  border:1px solid rgba(229,229,229,1);
  padding: 0 10px;
  margin-right: 10px;
}
.input230{
  width:230px;
  height:30px;
  background:rgba(255,255,255,1);
  border-radius:5px;
  border:1px solid rgba(229,229,229,1);
  padding: 0 10px;
}
.input540{
  width:540px;
  height:30px;
  background:rgba(255,255,255,1);
  border-radius:5px;
  border:1px solid rgba(229,229,229,1);
  padding: 0 10px;
}
.input95{
  width:95px;
  height:30px;
  background:rgba(255,255,255,1);
  border-radius:5px;
  border:1px solid rgba(229,229,229,1);
  padding: 0 10px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.inputTextarea{
  width:540px;
  height:60px;
  background:rgba(255,255,255,1);
  border-radius:5px;
  border:1px solid rgba(229,229,229,1);
  padding: 0 10px;
  resize: none;
}
.cityBox{
    width:92px;
    height:300px;
    background:rgba(255,255,255,1);
    border-radius:5px;
    border:1px solid rgba(229,229,229,1);
    text-align:center;
    position: absolute;
    top:30px;
    left: 0;
    box-sizing: border-box;
    overflow-y: auto;
}
.cityslect{
  overflow: hidden;
}
.inputBtnBox{
  display: flex;
  justify-content: space-between;
}
.inputBtnBack{
  width:110px;
  height:36px;
  background:rgba(229,229,229,1);
  border-radius:5px;
  border:1px solid rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  font-size:14px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(120,120,120,1);
  line-height: 36px;

}
.inputBtnBack img{
  height:11px;
  width: 8px;
  transform:rotate(180deg);
  -ms-transform:rotate(180deg);   /* IE 9 */
  -moz-transform:rotate(180deg);  /* Firefox */
  -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
  -o-transform:rotate(180deg);  /* Opera */
  position: relative;
  top:12px;
  margin-right: 5px;
}
.inputBtnPay{
  width:150px;
  height:36px;
  background:rgba(106,181,28,1);
  border-radius:5px;
  display: flex;
  justify-content: center;
  font-size:14px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height: 36px;
}
.inputBtnPay img{
  height:11px;
  width: 8px;
  position: relative;
  top:12px;
  margin-left: 5px;
}
.chosePayBox{
  display: flex;
  height:20px;
  line-height:20px;
  margin-bottom: 13px;
  margin-top:17px; 
}
.chosePayBox img{
  width: 12px;
  height:12px;
  margin-right: 10px;
  position: relative;
  top:4px;
}
.chosePayBox div{
  font-size:14px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(120,120,120,1);
}
.showPayBox{
  display: flex;
  justify-content: center;
  width:110px;
  height:40px;
  background:rgba(255,255,255,1);
  border-radius:5px;
  border:2px solid rgba(229,229,229,1);
  line-height: 40px;
  margin-left: 22px;
  margin-bottom: 30px;
}
.showPayBox img{
  width: 28px;
  height:26px;
  position: relative;
  top:7px;
  margin-right: 6px;
}
.showPayBox div{
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(187,187,187,1);
}

.orderBox{
  padding: 30px;
  width: 800px;
  background:rgba(255,255,255,1);
  border-radius:10px;
  /*border:1px solid rgba(229,229,229,1);*/
  box-shadow:0px 0px 30px 0px rgba(202,196,191,0.31);
  margin:0 auto;
  max-height: 700px;
  overflow-y:auto; 
}
.orderAddress{
  height:130px;
  background:rgba(249,249,250,1);
  border-radius:5px;
  /*border:1px solid rgba(229,229,229,1);*/
  box-shadow:0px 0px 30px 0px rgba(202,196,191,0.31);
  display: flex;
  padding: 20px;
  margin: 30px 0;
}
.orderAddress img{
  width: 25px;
  height:34px;
  position: relative;
  top:28px;
}
.orderAddressBox{
  padding: 2px 19px 9px;
  text-align:left;
}
.orderAddressName{
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Medium;
  font-weight:600;
  color:rgba(120,120,120,1);
  line-height:25px;
  letter-spacing:1px;
}
.orderAddressidBox{
  display: flex;
  height:17px;
  font-size:12px;
  font-family:OpenSans;
  color:rgba(120,120,120,1);
  line-height:17px;
  margin: 10px 0;
}
.orderAddressPhone{
  margin-right: 26px;
}
.orderAddressIdCard{

}
.orderAddressDetail{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
  line-height:17px;
}
.orderGoods{
  width:740px;
  background:rgba(249,249,250,1);
  border-radius:5px;
  /*border:1px solid rgba(229,229,229,1);*/
  box-shadow:0px 0px 30px 0px rgba(202,196,191,0.31);
  padding: 20px;
  overflow: hidden;
}
.orderGoods .boxGoods{
  border-top: 0;
}
.orderGoodsTotle{
  float: right;
  padding: 18px 0;
}
.orderGoodsTotleBox{
  width: 200px;
  display: flex;
  justify-content: space-between;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(95,95,95,1);
  line-height:20px;
  margin-bottom: 8px;
}
.orderGoodsTotleBox2{
   width: 200px;
  display: flex;
  justify-content: space-between;
  height:22px;
  font-size:16px;
  font-family:PingFangSC-Medium;
  font-weight:600;
  color:rgba(95,95,95,1);
  line-height:22px;
  letter-spacing:1px;
  margin-top:5px;
}
.orderPay{
  display: flex;
  justify-content: space-between;
  height:36px;
  margin-top: 54px;
}
.orderPay .xjdfile{
  line-height:36px;
}
.orderPayBtn{
  display: flex;
}
.orderPayBtn img{
  width: 36px;
  height:36px;
  margin-right: 13px;
}

.wechatBox{
  padding: 30px;
  width: 600px;
  background:rgba(255,255,255,1);
  border-radius:10px;
  /*border:1px solid rgba(229,229,229,1);*/
  box-shadow:0px 0px 30px 0px rgba(202,196,191,0.31);
  margin:0 auto;
}
.wechatCodeBox{
  width: 200px;
  height:200px;
  background:rgba(216,216,216,1);
  margin:20px auto;
}
.wechatCodeBox img{
  width: 200px;
  height:200px;
  display: block;
}
.wechatCare{
  width:170px;
  height:23px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(106,181,28,1);
  line-height:22px;
  margin: 0 auto;
  /*border:1px solid rgba(106,181,28,1);*/
  box-shadow:0px 0px 30px 0px rgba(202,196,191,0.31);
  text-align:center;
}
.wechatFind{
  width: 330px;
  text-align:center;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Light;
  font-weight:300;
  color:rgba(95,95,95,1);
  line-height:20px;
  margin:20px auto;
}
</style>